import {dateFilterKeys} from 'shared/lib/filterHelper';

export const CITY_FILTER_KEYS = ['country.zone.id'];

export const LOCATION_FILTER_KEYS = ['published', 'city.country.zone.id', 'city.country.id'];

export const PROMO_CODE_FILTER_KEYS = [
    'published',
    'tariff.id',
    'activations[gte]',
    'activations[lte]',
    ...dateFilterKeys('expire_at'),
];

export const TARIFF_FILTER_KEYS = ['is_archive', 'is_default', 'is_recommended'];
